import type { AssetKey } from '../../../types/InfrastructureManagerTypes';

// One string per asset across layers, for Set/Map lookups (expansion, selection).
export const toAssetKey = ({ layerId, keyValue }: AssetKey) => `${layerId}:${keyValue}`;
